import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import '@fontsource-variable/fraunces';
import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';
import './styles/globals.css';
import { Providers } from '@/app/providers';
import { router } from '@/app/router';
import { IS_DEMO } from '@/lib/env';

// The demo build pins a banner above every screen and serves recorded images. The `@/demo/*` alias resolves to an inert
// stub in live builds, so none of this reaches the live bundle.
const DemoBanner = IS_DEMO ? lazy(() => import('@/demo/DemoBanner')) : null;
if (IS_DEMO) {
  document.documentElement.classList.add('demo-mode');
}
// The image swap must be in place before the first image is created, so the demo renders after it is installed.
const ready: Promise<void> = IS_DEMO
  ? import('@/demo/assets').then((module) => module.installDemoAssets())
  : Promise.resolve();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Missing #root element in index.html');
}

void ready.then(() => {
  createRoot(container).render(
    <StrictMode>
      {DemoBanner && (
        <Suspense fallback={null}>
          <DemoBanner />
        </Suspense>
      )}
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </StrictMode>,
  );
});
